// Notice: same model exists in server side
export enum StorageObjectType {
  None = 0,
  File = 1,
  Directory = 2
}
